export default "__VITE_ASSET__LdWkzpLm__"